import { Navigate, useLocation } from 'react-router-dom'

export const LEGACY_DOCUMENT_SIGN_PATH = '/documentos/assinar'

/** O link antigo abre o editor salvo; a escolha de assinar continua explícita na interface. */
export function LegacyDocumentSignRedirect() {
  const location = useLocation()
  const state = location.state as unknown
  const legacy = state && typeof state === 'object' && !Array.isArray(state)
    ? state as Record<string, unknown>
    : null
  const documentId = typeof legacy?.documentId === 'string' ? legacy.documentId.trim() : ''
  const nextState = documentId ? { ...legacy, openDocumentId: documentId } : state

  return <Navigate to={{ pathname: '/documentos', search: location.search, hash: location.hash }} state={nextState} replace />
}
